import { render, staticRenderFns } from "./cv-text-area.vue?vue&type=template&id=1ef26ad0&"
import script from "./cv-text-area.vue?vue&type=script&lang=js&"
export * from "./cv-text-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports